import { Direction, BidiModule } from '@angular/cdk/bidi';
import { Component, Inject, Renderer2 } from '@angular/core';
import { DirectionService, InConfiguration } from '@core';
import { ConfigService } from '@config';
import { DOCUMENT } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { UnsubscribeOnDestroyAdapter } from '@shared';
import { CustomConfiguration } from '@core/models/custom-configuration.interface';

@Component({
    selector: 'app-auth-layout',
    templateUrl: './auth-layout.component.html',
    styleUrls: [],
    imports: [BidiModule, RouterOutlet]
})
export class AuthLayoutComponent extends UnsubscribeOnDestroyAdapter {
    direction!: Direction;
    public config!: InConfiguration & CustomConfiguration;

    constructor(
        @Inject(DOCUMENT) private document: Document,
        private _directoryService: DirectionService,
        private _configService: ConfigService,
        private _renderer: Renderer2,
    ) {
        super();

        this.config = this._configService.configData;
        this.subs.sink = this._directoryService.currentData.subscribe({
            next: (currentData) => {
                if (currentData) {
                    this.direction = currentData === 'ltr' ? 'ltr' : 'rtl';
                } else {
                    if (localStorage.getItem('isRtl')) {
                        if (localStorage.getItem('isRtl') === 'true') {
                            this.direction = 'rtl';
                        }
                        else if (localStorage.getItem('isRtl') === 'false') {
                            this.direction = 'ltr';
                        }
                    }
                    else {
                        if (this.config) {
                            if (this.config.layout.rtl === true) {
                                this.direction = 'rtl';
                                localStorage.setItem('isRtl', 'true');
                            }
                            else {
                                this.direction = 'ltr';
                                localStorage.setItem('isRtl', 'false');
                            }
                        }
                    }
                }
            }
        });

        // set theme on startup
        if (localStorage.getItem('theme')) {
            this._renderer.removeClass(this.document.body, this.config.layout.variant);
            this._renderer.addClass(
                this.document.body,
                localStorage.getItem('theme') as string
            );
        }
        else {
            this._renderer.addClass(this.document.body, this.config.layout.variant);
        }
    }
}
